<template>
  <b-card
    v-if="isVisible"
    title="Список эталонов"
  >
    <b-button @click="openReferenceList">
      Показать список эталонов
    </b-button>
  </b-card>
</template>

<script>
import {
  BButton,
  BCard,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ReferenceListPanel',

  components: {
    BButton,
    BCard,
  },

  props: {
    project: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isVisible: false,
    }
  },

  computed: {
    ...mapGetters('app', {
      apiAddr: 'apiAddr',
    }),
  },

  watch: {
    project: {
      handler() {
        this.checkReferenceList()
      },
      immediate: true,
    },
  },

  methods: {
    checkReferenceList() {
      if (!this.project) {
        this.isVisible = false
        return
      }

      fetch(`${this.apiAddr}${this.project}/api/reference-list`)
        .then(res => {
          this.isVisible = res.status === 200
        })
        .catch(() => {
          this.isVisible = false
        })
    },

    openReferenceList() {
      this.$router.push({ name: `reference-list-page-${this.project}` })
    },
  },
}
</script>
